import { render, staticRenderFns } from "./CoozzyStatisticsCard.vue?vue&type=template&id=c4af7efc&scoped=true"
import script from "./CoozzyStatisticsCard.vue?vue&type=script&lang=js"
export * from "./CoozzyStatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./CoozzyStatisticsCard.vue?vue&type=style&index=0&id=c4af7efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4af7efc",
  null
  
)

export default component.exports